{
  "familyId": "MET-OPP-PARALLELLOGRAM",
  "questions": [
    {
      "id": "MET-OPP-PARALLELLOGRAM-001",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Een parallellogram heeft een basis van 8 cm en een hoogte van 5 cm. Wat is de oppervlakte?",
      "options": ["40 cm²", "48 cm²", "20 cm²", "13 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 8,
            "height": 5,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte parallellogram",
            "content": "Oppervlakte parallellogram = basis × hoogte. De hoogte is de loodrechte afstand tussen de twee evenwijdige zijden, niet de schuine zijde!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Oppervlakte parallellogram = basis × hoogte = 8 × 5 = 40 cm². Een parallellogram is qua oppervlakte gelijk aan een rechthoek met dezelfde basis en hoogte (knip-en-plak principe). Let op: gebruik de loodrechte hoogte, niet de schuine zijde.",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "Basis = 8 cm, hoogte = 5 cm",
          "8 × 5 = 40 cm²"
        ],
        "distractorExplanations": {
          "0": "Goed! Basis × hoogte = 8 × 5 = 40 cm².",
          "1": "Je gebruikte de schuine zijde (6 cm) i.p.v. de loodrechte hoogte (5 cm). Hoogte staat altijd loodrecht op de basis.",
          "2": "Je deed (8 × 5) ÷ 2 = 20. Dat is de driehoekformule. Een parallellogram is dubbel zo groot — geen ÷ 2.",
          "3": "Je deed 8 + 5 = 13. Oppervlakte bereken je met vermenigvuldigen, niet met optellen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.parallellogram-schuine-zijde-vs-hoogte", "label": "Schuine zijde i.p.v. hoogte gebruikt", "optionIndex": 1 },
          { "id": "met.parallellogram-driehoek-formule", "label": "Driehoekformule (÷ 2) op parallellogram", "optionIndex": 2 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-002",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Een parallellogram heeft een basis van 12 cm, een schuine zijde van 7 cm, en een hoogte van 6 cm. Welke maten gebruik je voor de oppervlakte?",
      "options": [
        "Basis (12 cm) en schuine zijde (7 cm)",
        "Schuine zijde (7 cm) en hoogte (6 cm)",
        "Basis (12 cm) en hoogte (6 cm)",
        "Alle drie de maten"
      ],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 12,
            "height": 6,
            "slantSide": 7,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welke maten?",
            "content": "Voor de oppervlakte van een parallellogram gebruik je alleen de basis en de hoogte. De schuine zijde gebruik je NIET. De hoogte staat altijd loodrecht op de basis.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_maten",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Je gebruikt de basis (12 cm) en de hoogte (6 cm). De schuine zijde (7 cm) heb je niet nodig voor de oppervlakte — die is alleen relevant voor de omtrek. Oppervlakte = 12 × 6 = 72 cm².",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "Basis = 12 cm, hoogte = 6 cm",
          "Schuine zijde (7 cm) is niet nodig",
          "12 × 6 = 72 cm² ✓"
        ],
        "distractorExplanations": {
          "0": "De schuine zijde is voor de omtrek, niet voor de oppervlakte. Hoogte = loodrecht op de basis.",
          "1": "Je hebt de basis nodig, niet de schuine zijde. Oppervlakte = basis × hoogte.",
          "2": "Goed! Alleen basis en hoogte zijn nodig.",
          "3": "Voor de oppervlakte zijn alleen basis en hoogte nodig. De schuine zijde gebruik je voor de omtrek."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.parallellogram-schuine-zijde-vs-hoogte", "label": "Schuine zijde i.p.v. hoogte", "optionIndex": 0 },
          { "id": "met.parallellogram-schuine-zijde-vs-hoogte", "label": "Schuine zijde i.p.v. basis", "optionIndex": 1 },
          { "id": "met.parallellogram-alle-zijden-gebruikt", "label": "Denkt dat alle maten nodig zijn", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-003",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Waarom is de oppervlakte van een parallellogram gelijk aan basis × hoogte (dezelfde formule als een rechthoek)?",
      "options": [
        "Omdat een parallellogram altijd even groot is als een rechthoek",
        "Omdat je een parallellogram kunt 'knippen en plakken' tot een rechthoek",
        "Omdat alle vierhoeken dezelfde formule hebben",
        "Omdat de schuine zijden er niet toe doen"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Parallellogram → rechthoek",
            "content": "Als je een driehoek van de ene kant van een parallellogram afknipt en aan de andere kant plakt, krijg je een rechthoek. Daarom is de oppervlakte hetzelfde: basis × hoogte.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_begrip",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Knip een driehoekje aan de schuine kant af en plak het aan de andere kant — je krijgt een rechthoek met dezelfde basis en hoogte. De oppervlakte verandert niet. Daarom geldt: basis × hoogte.",
        "solutionSteps": [
          "Knip een driehoek af aan de schuine kant",
          "Plak die driehoek aan de andere kant",
          "Resultaat: een rechthoek met dezelfde basis en hoogte",
          "Oppervlakte rechthoek = basis × hoogte → ook voor parallellogram ✓"
        ],
        "distractorExplanations": {
          "0": "Niet elk parallellogram is even groot als een rechthoek. Het punt is dat je het kunt omvormen naar een rechthoek met dezelfde basis en hoogte.",
          "1": "Goed! Door knippen en plakken maak je een rechthoek met dezelfde oppervlakte.",
          "2": "Niet alle vierhoeken hebben dezelfde formule. Trapezium en ruit hebben andere formules.",
          "3": "De schuine zijden doen er wél toe — voor de omtrek. Voor oppervlakte niet, en de echte reden is het knip-en-plak principe."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.parallellogram-conceptueel-onbegrepen", "label": "Onbegrepen reden formule", "optionIndex": 0 },
          { "id": "met.opp-formule-overgegeneraliseerd", "label": "Generaliseert formule naar alle vierhoeken", "optionIndex": 2 },
          { "id": "met.parallellogram-conceptueel-onbegrepen", "label": "Onbegrepen reden formule", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-004",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Een dakvlak heeft de vorm van een parallellogram met een basis van 6 m en een hoogte van 2,5 m. Hoeveel m² dakbedekking is er nodig?",
      "options": ["17 m²", "7,5 m²", "30 m²", "15 m²"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 6,
            "height": 2.5,
            "showGrid": false,
            "unit": "m",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte met kommagetallen",
            "content": "Oppervlakte = basis × hoogte. Met kommagetallen: 6 × 2,5 = 15. Tip: 6 × 2 = 12, en 6 × 0,5 = 3. Samen: 12 + 3 = 15 m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_context",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Oppervlakte = basis × hoogte = 6 × 2,5 = 15 m². Splits handig: 6 × 2 = 12 en 6 × 0,5 = 3, samen 15.",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "6 × 2,5 = 15",
          "Eenheid: m × m = m²",
          "Antwoord: 15 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Je deed 2 × (6 + 2,5) = 17. Dat is de omtrek, niet de oppervlakte.",
          "1": "Je deed 6 × 2,5 ÷ 2 = 7,5. Dat is de driehoekformule. Een parallellogram heeft geen ÷ 2.",
          "2": "Je deed 6 × 5 = 30 of 12 × 2,5. Reken 6 × 2,5 nog eens na: 15.",
          "3": "Goed! 6 × 2,5 = 15 m²."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Omtrek i.p.v. oppervlakte", "optionIndex": 0 },
          { "id": "met.parallellogram-driehoek-formule", "label": "Driehoekformule gebruikt", "optionIndex": 1 },
          { "id": "met.opp-rekenfout", "label": "Rekenfout met kommagetallen", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-005",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "fill_in",
      "question": "Een parallellogram heeft een oppervlakte van 54 cm² en een basis van 9 cm. Hoe hoog is het parallellogram? Geef je antwoord in cm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6", "6 cm"],
        "caseSensitive": false,
        "placeholder": "? cm"
      },
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 9,
            "height": null,
            "hideHeight": true,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true,
            "area": 54
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogte berekenen",
            "content": "Als je de oppervlakte en de basis weet: hoogte = oppervlakte ÷ basis = 54 ÷ 9 = 6 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_hoogte",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Oppervlakte = basis × hoogte. Omdraaien: hoogte = oppervlakte ÷ basis = 54 ÷ 9 = 6 cm. Check: 9 × 6 = 54 cm² ✓.",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "Omdraaien: hoogte = oppervlakte ÷ basis",
          "54 ÷ 9 = 6 cm",
          "Check: 9 × 6 = 54 cm² ✓"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "hasStructuredData": true
      }
    }
  ]
}